import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function MobileFormWrapper({ children }) {
  const [isMobile, setIsMobile] = useState(false);
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  const MOBILE_HEADER_H = 100; // px — visual height of your fixed header on phones
  const MOBILE_FOOTER_H = 100; // px — visual height of your fixed footer on phones
  const MOBILE_GAP = "clamp(8px, 4vh, 20px)"; // breathing room between panel & bars

  const FROM_RIGHT = true;

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!isMobile) return;
    setVisible(false);
    const id = setTimeout(() => setVisible(true),400);
    return () => clearTimeout(id);
  }, [isMobile, location.pathname]);

  if (!isMobile) return <>{children}</>;

  const HIDDEN_CLASS = FROM_RIGHT
    ? "translate-x-[110%]"
    : "-translate-x-[110%]";
  const VISIBLE_CLASS = "translate-x-0";

  return (
    <div
      className={[
        "loginSignupWrapper fixed right-0 z-40",
        "bg-white shadow-lg border border-black/10 rounded-xl",
        "transform-gpu will-change-transform",
        "transition-transform duration-500 ease-[cubic-bezier(.22,.7,.26,1)]",
        visible ? VISIBLE_CLASS : HIDDEN_CLASS,
      ].join(" ")}
      style={{
        top: `${MOBILE_HEADER_H}px`,
        bottom: `${MOBILE_FOOTER_H}px`,
        marginTop: "15px",
        marginBottom: "15px",
        visibility: visible ? "visible" : "hidden",
      }}
    >
      {/* content scrolls inside the available vertical space */}
      <div className="h-full overflow-auto px-3 py-3">{children}</div>
    </div>
  );
}

/*
  Tailwind purge safelist note:
  -translate-x-[110%] translate-x-[110%]
*/
